import { Observable, of } from 'rxjs'
import { catchError, merge } from 'rxjs/operators'

import { Featured, Container } from '@skinsoft/types'
import { containerSelectors } from '..'
import { resolveAuthor } from '../../resolve-author'

export function toFeatured$(container: Container): Observable<Featured> {
    const featured = {
        description: containerSelectors.title(container),
        id: containerSelectors.id(container),
        title: containerSelectors.identifier(container),
        state: '',
        stateLabel: '',
        author: containerSelectors.author(container),
    };

    const featured$ = of(featured);

    return featured$.pipe(
        merge(of({ ...featured, author: null } as Featured), featured$.pipe(
            resolveAuthor,
        ) as Observable<Featured>),
        catchError(error => of({...featured, author: error}))
    );
}
